import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Vehicle, PurchaseMethods } from '@sm360/widget-commons-vehicle';

import ListingSEOText from 'inventory-listing/components/ListingSEOText/ListingSEOText.jsx';

import './ListingFooter.scss';

const ListingFooter = ({ purchaseMethods, colanderGroupSlug }) => {
    const genericDisclaimers = purchaseMethods &&
        purchaseMethods.disclaimers && [
            purchaseMethods.disclaimers.dataResponsibility,
            purchaseMethods.disclaimers.priceChange,
        ];
    return (
        <div className="listing-footer">
            <div className="sr-disclaimer">
                <Vehicle.VehicleDisclaimersContent genericDisclaimers={genericDisclaimers} />
            </div>
            <ListingSEOText colanderGroupSlug={colanderGroupSlug} />
        </div>
    );
};

ListingFooter.propTypes = {
    colanderGroupSlug: PropTypes.string.isRequired,
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel).isRequired,
};

function mapStateToProps({ purchaseMethods }) {
    return { purchaseMethods };
}

export { ListingFooter };

export default connect(mapStateToProps)(ListingFooter);



// WEBPACK FOOTER //
// ./client/src/components/ListingUsed/ListingFooter/ListingFooter.jsx